import { render, staticRenderFns } from "./service-public-data.vue?vue&type=template&id=61b8b5d2&"
import script from "./service-public-data.vue?vue&type=script&lang=js&"
export * from "./service-public-data.vue?vue&type=script&lang=js&"
import style0 from "./service-public-data.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports